//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'blog',

  data() {
    return { activeId: null };
  },

  async asyncData({ $content, params, error }) {
    const segments = params.pathMatch ? params.pathMatch.split('/') : [];

    if (!segments.length) {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    const slug = segments.pop();
    const dir = segments.length ? `root/${segments.join('/')}` : 'root';

    const page = await $content(dir, slug)
      .fetch()
      .catch(() => error({ statusCode: 404, message: 'Page not found' }));

    const recentPosts = await $content('blog')
      .only(['title', 'slug', 'excerpt', 'featuredImage', 'publishedOn'])
      .sortBy('publishedOn', 'desc')
      .limit(3)
      .fetch();

    return { page, recentPosts };
  },

  mounted() {
    if (!this.page.toc || !this.page.toc.length) return;

    const headings = document.querySelectorAll(
      '.nuxt-content h2, .nuxt-content h3'
    );
    if (!headings.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.activeId = entry.target.id;
        });
      },
      { rootMargin: '-10% 0px -80% 0px' }
    );

    headings.forEach((h) => observer.observe(h));
    this.$once('hook:beforeDestroy', () => observer.disconnect());
  },

  head() {
    return {
      title: `${this.page.title} | BOMIST`,
      meta: [
        ...(this.page.excerpt
          ? [
              {
                hid: 'description',
                name: 'description',
                content: this.page.excerpt
              },
              {
                hid: 'og:description',
                property: 'og:description',
                content: this.page.excerpt
              },
              {
                hid: 'twitter:description',
                name: 'twitter:description',
                content: this.page.excerpt
              }
            ]
          : []),
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${this.page.title} | BOMIST`
        },
        ...(this.page.featuredImage
          ? [
              {
                hid: 'og:image',
                property: 'og:image',
                content: `https://bomist.com${this.page.featuredImage}`
              },
              {
                hid: 'twitter:image',
                name: 'twitter:image',
                content: `https://bomist.com${this.page.featuredImage}`
              }
            ]
          : []),
        { hid: 'og:type', property: 'og:type', content: 'website' },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: `${this.page.title} | BOMIST`
        }
      ]
    };
  }
};
